import React from "react";

import { Header } from '../../Components/Layout/Header.jsx';
import { GameDetails } from '../../Components/Game/GameDetails.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { Game } from '../../Components/Game/Game.jsx';

import { Banners } from '../../Components/Banner/Banners.jsx';
import { MojCasino } from '../../Components/Casino/MojCasino.jsx';

export class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            igre: null,
            categories: null,
            selectedCategoryId: -1,
            showSort: false,
            categoriesSort: null,
            defaultCategorySort: null,
            urlCategory: null,
            igraDana: null,
            lazyLoadPageIndex: 0,
        }

        this.lazyLoadPageWrapper = React.createRef();

        this.setData = this.setData.bind(this);
        this.changeKategorija = this.changeKategorija.bind(this);
        this.showKategorija = this.showKategorija.bind(this);
        this.dohvatiIgrePremaTrenutnojKategoriji = this.dohvatiIgrePremaTrenutnojKategoriji.bind(this);
        this.renderIgra = this.renderIgra.bind(this);
        this.renderKategorija = this.renderKategorija.bind(this);
        this.renderMojeIgreKategorija = this.renderMojeIgreKategorija.bind(this);
        this.getCategorySortCode = this.getCategorySortCode.bind(this);
        this.gameContainer = React.createRef();
        this._isMounted = false;
        this._htmlStuffTimer = null;

        casino.utils.createPageGoogleTagManagerEvent('Casino', 'Home', 'casino', this.props.user ? this.props.user : null);
    }

    componentDidMount() {
        this._isMounted = true;

        const historyAction = this.props.route?.history?.action;
        if (historyAction === 'POP') {
            const savedPosition = casino.utils.getScrollPosition('/');
            if (savedPosition > 0) {
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        window.scrollTo(0, savedPosition);
                    }, 100);
                });
            } else {
                window.scrollTo(0, 0);
            }
        } else {
            window.scrollTo(0, 0);
        }

        this.props.showMenuFn(false);
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });

        this.setState({ urlCategory: decodeURI(casino.utils.getUrlParameters("game_category")["game_category"]) });
    }

    componentWillUnmount() {
        this._isMounted = false;

        casino.utils.saveScrollPosition('/', window.scrollY);

        clearTimeout(this._htmlStuffTimer);
        if (this.dataPromises) this.dataPromises.cancel();
        this.props.showLoadingFn(false);

        this.lazyLoadClean();
    }

    //logika prebacena u componentDidUpdate
    // componentWillReceiveProps(nextProps) {
    //     // ako se user odjavi a na kategoriji je moje igre onda moramo prebaciti na prvu kategoriju
    //     if (nextProps.userChecked && (!nextProps.user || nextProps.user.favoriti.length == 0)) {
    //         if (this.state && this.state.selectedCategoryId == 0) {
    //             this.changeKategorija(this.state.categories[0].id);
    //         }
    //     }
    // }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.userChecked &&
            this.props.user?.favoriti.length &&
            prevState.categories &&
            !prevState.categories.find(cat => cat.id === 0)) {
            const updatedCategories = [...prevState.categories];
            updatedCategories.push({ id: 0, name: 'Moje igre', icon: 'ico-star-fill' });

            const urlCategory = decodeURI(casino.utils.getUrlParameters("game_category")["game_category"]);
            const urlInfo = casino.utils.parseQuery(this.props.route.location.search);

            this.setState(prevState => {
                let selectedCategoryId = prevState.selectedCategoryId;

                if (urlCategory?.toLowerCase() === 'moje igre' || (parseInt(urlInfo.lasttab) == 0)) {
                    selectedCategoryId = 0;
                } 

                return {
                    categories: updatedCategories,
                    selectedCategoryId: selectedCategoryId
                };
            });
        }

        if (prevProps.user && !this.props.user) {
            if (this.state.categories?.length > 0) {
                    this.changeKategorija(-1);
            }
        }

        if (this.state.igre && !this._didHtmlStuff) {
            this._didHtmlStuff = true;

            if (this.props.route && this.props.route.location.search) {
                var urlInfo = casino.utils.parseQuery(this.props.route.location.search);

                this._htmlStuffTimer = setTimeout(() => {
                    this._htmlStuffTimer = null;
                    if (!this._isMounted) return;

                    if (urlInfo.lasttab != "" && document.getElementById("categories-swiper") && document.getElementById("categories-swiper").getElementsByClassName("selected").length) {
                        var offsetLeft = document.getElementById("categories-swiper").getElementsByClassName("selected")[0].offsetLeft
                        document.getElementById("categories-swiper").scrollLeft = offsetLeft - 100;
                    }

                    if (urlInfo.lasttab == -1) {
                        if (urlInfo.lastfrom) {
                            let div = urlInfo.lastfrom.split('-').length == 3 ? urlInfo.lastfrom.split('-')[0] + '-' + urlInfo.lastfrom.split('-')[1] : urlInfo.lastfrom;
                            if (urlInfo.lastfrom && document.getElementById(div)) {
                                requestAnimationFrame(() => {
                                    document.getElementById(div).scrollIntoView({ behavior: "auto", block: "center", inline: "nearest" });
                                });
                            }
                        }
                    }
                    else {
                        if (urlInfo.lastgame && document.getElementById("game-" + urlInfo.lastgame)) {
                            requestAnimationFrame(() => {
                                document.getElementById("game-" + urlInfo.lastgame).scrollIntoView({ behavior: "auto", block: "center", inline: "nearest" });
                            });
                        } else {
                            var swiper = document.getElementById("categories-swiper");
                            if (swiper) {
                                requestAnimationFrame(() => {
                                    swiper.scrollIntoView({ behavior: "auto", block: "center", inline: "nearest" });
                                });
                            }
                        }
                    }
                }, 400);
            }
        }

        if (prevState.selectedCategoryId !== this.state.selectedCategoryId || prevState.searchText !== this.state.searchText) {
            this.lazyLoadClean();

            if (this.state.lazyLoadPageIndex) {
                this.setState({
                    lazyLoadPageIndex: 0,
                });
            } else {
                this.lazyLoadInit();
            }
        }

        if (prevState.lazyLoadPageIndex !== this.state.lazyLoadPageIndex) {
            this._startLazyImages = true;
            this.lazyLoadInit();
        }

        if (this._startLazyImages) {
            casino.utils.lazyImages.mountEventLazyLoadImages();
            this._startLazyImages = false;
        }
    }

    lazyLoadIntersect([entry]) {
        if (!entry.isIntersecting) {
            return;
        }

        this.lazyLoadClean();

        this.setState({
            lazyLoadPageIndex: this.state.lazyLoadPageIndex + 1,
        });
    }

    setData(data) {
        const [igre, kategorije] = data;

        let igraDanaArray = igre && igre.filter(x => !!x.kt && Object.keys(x.kt).indexOf('54') != -1).sort((igra1, igra2) =>
            igra1.kt['54'] < igra2.kt['54'] ? -1 : 1);

        let igraDana = igraDanaArray?.length ? igraDanaArray[0] : null;

        const urlInfo = casino.utils.parseQuery(this.props.route.location.search);
        let selectedCategoryId = -1;

        if (!this.props.userChecked && this.props.user?.favoriti.length == 0) {
            if (parseInt(urlInfo.lasttab) == 0) {
                selectedCategoryId = -1;
            }
        }

        if (kategorije?.items) {
            if (urlInfo.lasttab) {
                const parsedTab = parseInt(urlInfo.lasttab);
                if (kategorije.items.some(cat => cat.id === parsedTab)) {
                    selectedCategoryId = parsedTab;
                }
            } else if (urlInfo.game_category) {
                const urlCategory = decodeURI(urlInfo.game_category);
                const matchingCategory = kategorije.items.find(
                    cat => cat.name.toLowerCase() === urlCategory.toLowerCase()
                );
                if (matchingCategory) {
                    selectedCategoryId = matchingCategory.id;
                }
            }
        }

        this.setState({
            igre: igre,
            igraDana: igraDana,
            categories: kategorije.items,
            selectedCategoryId: selectedCategoryId,
            categoriesSort: kategorije.sortOptions,
        });

        this.props.setTabCategoryFn(selectedCategoryId);
        this.props.showLoadingFn(false);
        this._startLazyImages = true;
    }


    changeKategorija(id) {
        if (!this.state.categories) return;

        this.setState({
            selectedCategoryId: id,
            showSort: false
        });

        this.props.setTabCategoryFn(id) //set global category state to current id.
        if (id == -1) { //if moj casino tab selected remove url parameter.
            history.pushState({}, null, '');
        }

        this._startLazyImages = true;

        let category = this.state.categories.find(it => it.id == id);

        if (category) {
            casino.utils.createClickGoogleTagManagerEvent(category.name, 'all', 'casino', this.props.user);

            history.pushState({}, null, `?game_category=${category.name.toLowerCase()}`);
        }
    }

    showKategorija(name) {
        if (this.state && this.state.categories) {
            //ako nema zeljene kategorije uzmemo prvu
            var kategorija = this.state.categories.filter(x => x.name.toLowerCase() == name.toLowerCase())[0] || this.state.categories[0];
            if (kategorija) {
                this.changeKategorija(kategorija.id);

                if (this.gameContainer.current) {
                    this.gameContainer.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                }
                var header = document.getElementById("header");
                if (header) {
                    header.classList.add("skriveno");
                    header.classList.remove("plivaj");
                }

                // var top = this.gameContainer.current.getBoundingClientRect().top;
                // casino.utils.scroolTopAnimation(top - 5);
            }
        }
    }

    dohvatiIgrePremaTrenutnojKategoriji() {
        var that = this;

        let trenutnaKategorijaId = this.state.selectedCategoryId;
        let trenutnaKategorija = this.state.categories && this.state.categories.filter(x => x.id == trenutnaKategorijaId)[0];
        let trenutniSort = localStorage.getItem(this.getCategorySortCode(trenutnaKategorijaId)) || (trenutnaKategorija && trenutnaKategorija.defaultSort);
        let searchText = this.state.searchText && this.state.searchText.toLowerCase() || '';

        let igre = [];
        if (trenutnaKategorijaId == 0) { // to su faovriti
            igre = this.state.igre.filter(function (igra) {
                return that.props.user && that.props.user.favoriti.indexOf(igra.id) != -1;
            })
        } else {
            igre = this.state.igre.filter(function (igra) {
                return igra.kt && Object.keys(igra.kt).indexOf(trenutnaKategorijaId.toString()) != -1;
            })
        }

        if (searchText)
            igre = igre.filter(x => x.n.toLowerCase().indexOf(searchText) > -1);
        return igre.sort(function (igra1, igra2) {
            if (trenutniSort == 4)
                return igra1.n < igra2.n ? -1 : 1;

            if (trenutniSort == 3)
                return igra1.so[1] > igra2.so[1] ? -1 : 1;

            if (trenutniSort == 2)
                return igra1.so[0] > igra2.so[0] ? -1 : 1;

            return (igra1.kt?.[trenutnaKategorijaId.toString()] ?? 0) < (igra2.kt?.[trenutnaKategorijaId.toString()] ?? 0) ? -1 : 1;
        });
    }

    shouldUseLazyLoad() {
        // Do not lazy load, no page size prop defined or no
        // page wrapper ref element.
        if (!this.props.lazyLoadPageSize || !this.lazyLoadPageWrapper.current?.lastElementChild) {
            return false;
        }

        // From render method - not rendering games (no need for
        // lazy loading).
        if (!this.state.igre || this.state.selectedCategoryId === -1) {
            return false;
        }

        // No need for lazy loading based on page size and index.
        if (this.dohvatiIgrePremaTrenutnojKategoriji().length <= this.props.lazyLoadPageSize * (this.state.lazyLoadPageIndex + 1)) {
            return false;
        }

        return true;
    }

    lazyLoadClean() {
        if (!this.lazyLoadObserver) {
            return;
        }

        this.lazyLoadObserver.disconnect();
        this.lazyLoadObserver = null;
    }

    lazyLoadInit() {
        this.lazyLoadClean();

        if (!this.shouldUseLazyLoad()) {
            return;
        }

        const lastElement = this.lazyLoadPageWrapper.current.lastElementChild,
            offset = isNaN(this.props.lazyLoadOffset * 1) ? 256 : this.props.lazyLoadOffset*1,
            options = { rootMargin: `0px 0px ${offset}px 0px` },
            observer = new IntersectionObserver(this.lazyLoadIntersect.bind(this), options);

        this.lazyLoadObserver = observer;
        this.lazyLoadObserver.observe(lastElement);
    }

    renderIgra(igra, i) {
        return <Game brands={this.props.brands} categories={this.state.categories} ref={"game-" + igra.id} key={igra.s} igra={igra} showJackpot={true} goLazyImage={i > 6} />;
    }

    renderKategorija(kategorija) {
        var cssClass = "";
        if (kategorija.id == this.state.selectedCategoryId) {
            cssClass = "selected";
        }

        var icon = null;
        if (kategorija.icon)
            var icon = <span className={'icon ' + kategorija.icon}></span>;

        return (
            <li key={kategorija.id} className={cssClass}>
                <button
                    onClick={() => this.changeKategorija(kategorija.id)}
                >
                    {icon}<span>{kategorija.name}</span>
                </button>
            </li>
        );
    }
    renderMojeIgreKategorija() {
        if (this.props.userChecked && this.props.user && this.props.user.favoriti.length) {
            return this.renderKategorija({ id: 0, name: 'Moje igre', icon: 'ico-star-fill' });
        }
    }
    renderMojCasinoKategorija() {
        return this.renderKategorija({ id: -1, name: 'Moj casino', icon: '' });
    }
    getCategorySortCode(trenutnaKategorijaId) {
        return "category-sort-" + trenutnaKategorijaId;
    }
    render() {
        var trenutnaKategorijaId = this.state.selectedCategoryId;
        var trenutnaKategorija = this.state.categories && this.state.categories.filter(x => x.id == trenutnaKategorijaId)[0];
        var trenutnaKategorijaSort = trenutnaKategorija && trenutnaKategorija.defaultSort;
        var filteri = this.state.categoriesSort && this.state.categoriesSort.filter(x => x.alwaysVisible || x.id == trenutnaKategorijaSort);

        let height = filteri && (44 * filteri.length + 2 + 12) + 'px';

        let trenutniSort = localStorage.getItem(this.getCategorySortCode(trenutnaKategorijaId)) || (trenutnaKategorija && trenutnaKategorija.defaultSort);
        return (
            <>
                <Header key="header" {...this.state} {...this.props} />

                <div className="app-notification hidden">
                    <span className="icon ico-info"></span>
                    <span className="app-notification-text">
                        Zbog radova na poboljšanju i unaprjeđenju sustava mogući su
                        prekidi u radu casino stranice, 13.08.2026. u periodu od 04:45h do 05:45h.
                    </span>
                </div>

                {this.state.igre && <Banners
                    brands={this.props.brands}
                    igraDana={this.state.igraDana}
                    categories={this.state.categories}
                    showKategorijaFn={this.showKategorija}
                    showPopUpFn={this.props.showPopUpFn}
                    jackpots={this.props.jackpots}
                    noveIgreBanner={this.props.noveIgreBanner}
                    maradonaIgreBanner={this.props.maradonaIgreBanner}
                    user={this.props.user}
                    userChecked={this.props.userChecked}></Banners>}

                <div id="page-wrapper" className="no-padding grey">
                    {/*<Maraton  {...this.state} {...this.props}></Maraton>*/}
                    {/* <TopGames {...this.state} {...this.props}></TopGames> */}

                    <div id="game-container" className="maximum margin-center home-page" ref={this.gameContainer}>
                        <div style={{ position: 'relative' }}>
                            <div id="game-tabs" className="relative">
                                <div className="transparent-background-white-transparent kategorije-transparent kategorije-transparent-first"></div>
                                <div className="maximum">
                                    <ul className="tick" id="categories-swiper">
                                        {this.state.categories && this.renderMojCasinoKategorija()}
                                        {this.state.categories && this.state.categories.filter(x => x.aktivno).map(this.renderKategorija)}
                                        {this.state.categories && this.renderMojeIgreKategorija()}
                                    </ul>
                                </div>
                                <div className="transparent-background-transparent-white  kategorije-transparent kategorije-transparent-last"></div>
                            </div>
                        </div>
                        {this.state.selectedCategoryId > -1 && <div className="clearfix games-container  tabs-game-filter  ">
                            <input type="text" placeholder={"Pretraži igre"} className="search-games  game-item"
                                value={this.state.searchText} onChange={(e) => this.setState({ searchText: e.target.value })}></input>
                            <select placeholder={"SortOrder"} className="search-games advanced  game-item"
                                value={trenutniSort}
                                onChange={(e) => {
                                    this.setState({ defaultCategorySort: e.target.value });
                                    localStorage.setItem(this.getCategorySortCode(trenutnaKategorijaId), e.target.value);
                                    if (typeof ga !== 'undefined') // google analytics
                                        ga('send', { hitType: 'event', eventCategory: 'Clicks', eventAction: 'SortTabovi-' + filteri.filter(x => x.id == e.target.value).name });
                                }
                                }>
                                {filteri && filteri.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
                            </select>
                        </div>}

                        <div className={"clearfix white games-container"} ref={this.lazyLoadPageWrapper} style={(this.state.igre && this.state.selectedCategoryId == -1) ? { padding: '0px' } : {}} >
                            {!this.state.igre && <div className="game-loading">Dohvaćanje igara...</div>}

                            {true
                                && this.state.igre
                                && this.state.selectedCategoryId > -1
                                && this.dohvatiIgrePremaTrenutnojKategoriji()
                                    .slice(0, this.props.lazyLoadPageSize ? this.props.lazyLoadPageSize * (this.state.lazyLoadPageIndex + 1) : undefined)
                                    .map(this.renderIgra)
                            }

                            {this.state.igre && this.state.selectedCategoryId == -1 &&
                                <div className="relative maximum no-buttons moj-casino"><MojCasino showKategorijaFn={this.showKategorija}  {...this.state}  {...this.props} /></div>}
                        </div>
                    </div>
                </div>
                <GameDetails  {...this.props} {...this.state}></GameDetails>
                <ObavijestiCasino {...this.props}></ObavijestiCasino>
            </>
        )
    }
};